import ErrorBoundary from './error_boundary';

export default ErrorBoundary;
